export interface CikisiClient {
  id: number;
  name: string;
}

export class Organization {
  name!: string;
  slug!: string;
  createdAt!: string;
  role: string | null = null;
  membersCount: number | null = null;
  cikisiClient: CikisiClient | null = null;
  /** Whether this org can use Cikisi-only search filtering gates the
   *  "Search only Cikisi content" section in the playground (/rag, /answer,
   *  /search). Distinct from `cikisiClient`, which is a bound client
   *  reference, not an access flag. */
  isCikisiUser = false;

  constructor(data: any = {}) {
    this.name = data.name;
    this.slug = data.slug;
    this.createdAt = data.created_at;
    this.role = data.role ?? null;
    this.membersCount = data.members_count ?? null;
    this.cikisiClient = data.cikisi_client ?? null;
    this.isCikisiUser = !!data.is_cikisi_user;
  }
}
